module.exports = __webpack_public_path__ + "static/media/getItOnGooglePlay@2x.d0ec173e.png";